import classNames from 'classnames'
import React from 'react'
import {Button} from 'wix-ui-tpa/cssVars'
import {classes} from './no-events-button.st.css'
import {NoEventsButtonProps} from '.'

export const NoEventsButton = (props: NoEventsButtonProps) => <Button {...props} className={classNames(classes.root)} />
